module.exports = __webpack_public_path__ + "static/img/head01s.7b40722.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/index/head01s.png
// module id = CzG0
// module chunks = 1